import { createReducer, on } from '@ngrx/store';
import * as correctiveAction from '../actions/corrective-action.actions';
import { CorrectiveAction } from '../../models/corrective-action.model';

export interface CorrectiveActionState {
  correctiveAction: CorrectiveAction[];
  error: any;
  loading: boolean;
}

export const initialState: CorrectiveActionState = {
  correctiveAction: [],
  error: null,
  loading: true,
};

export const correctiveActionReducer = createReducer(
  initialState,

  // Load actions
  on(correctiveAction.loadCorrectiveAction, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(
    correctiveAction.loadCorrectiveActionSuccess,
    (state, { correctiveAction: actions }) => ({
      ...state,
      correctiveAction: actions,
      loading: false,
      error: null,
    })
  ),

  on(correctiveAction.loadCorrectiveActionFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Batch operations loading states
  on(
    correctiveAction.deleteMultipleCorrectiveActions,
    correctiveAction.createMultipleCorrectiveActions,
    correctiveAction.updateMultipleCorrectiveActions,
    (state) => ({
      ...state,
      loading: true,
      error: null,
    })
  ),

  on(
    correctiveAction.deleteMultipleCorrectiveActionsSuccess,
    (state, { uids }) => ({
      ...state,
      correctiveAction: state.correctiveAction.filter(
        (action) => !uids.includes(action.uid)
      ),
      loading: false,
      error: null,
    })
  ),

  on(
    correctiveAction.createMultipleCorrectiveActionsSuccess,
    (state, { correctiveActions }) => ({
      ...state,
      correctiveAction: [...state.correctiveAction, ...correctiveActions],
      loading: false,
      error: null,
    })
  ),

  on(
    correctiveAction.updateMultipleCorrectiveActionsSuccess,
    (state, { correctiveActions }) => ({
      ...state,
      correctiveAction: state.correctiveAction.map((action) => {
        const updated = correctiveActions.find((ca) => ca.uid === action.uid);
        return updated || action;
      }),
      loading: false,
      error: null,
    })
  ),

  // Error handling
  on(
    correctiveAction.deleteMultipleCorrectiveActionsFailure,
    correctiveAction.createMultipleCorrectiveActionsFailure,
    correctiveAction.updateMultipleCorrectiveActionsFailure,
    (state, { error }) => ({
      ...state,
      loading: false,
      error,
    })
  )
);
